<div class="representative-area">
  <div class="representative-data">
    <img *ngIf="generalizedRepresentative.picture" src="{{generalizedRepresentative.picture}}" alt="{{alt}}">
    <mat-icon *ngIf="!generalizedRepresentative.picture" [ngClass]="{'representative-photo': true, 'error': isExpired()}"
              [title]="getAlt()">person</mat-icon>
    <div class="info-data">
      <p class="name"
         title="{{getTitle()}}">
        {{ getTitle() }}
      </p>
      <p class="email"
         title="{{generalizedRepresentative.email}}">
        <a href="mailto:{{generalizedRepresentative.email}}">
          {{ generalizedRepresentative.email }}
        </a>
      </p>
    </div>
  </div>
  <div class="icons-area" *ngIf="!viewOnly">
    <div *ngIf="!isAdmin() && canTamper" [ngClass]="{ summary: isSummary }" class="icons-area-button">
      <ng-container [ngSwitch]="isRepresentative()">
        <div *ngSwitchCase="true"
            (click)="doPromote()"
            class="clickable-area"
            title="{{labels.promoteRep}}">
          <span class="label-small">{{ labels.promoteRep }}</span>
          <div class="icon">
            <div class="circle-icon">
              <mat-icon>account_box</mat-icon>
          </div>
          </div>
        </div>
        <div *ngSwitchCase="false"
            (click)="doResendInvite()"
            class="clickable-area"
            title="{{labels.resendInvite}}">
          <span class="label-small">{{ labels.resendInvite }}</span>
          <div class="icon">
            <div class="circle-icon">
              <mat-icon>schedule</mat-icon>
          </div>
          </div>
        </div>
      </ng-container>
    </div>
    <div (click)="doRemove()"
        class="clickable-area icons-area-button"
        title="{{labels.deleteRep}}"
        *ngIf="canDeleteRepresentative() && canTamper" >
      <span class="label-small">{{ labels.deleteRep }}</span>
      <div class="icon"
          title="{{labels.deleteRep}}">
          <div class="circle-icon">
              <mat-icon>delete</mat-icon>
          </div>
      </div>
    </div>
  </div>
</div>
